import './App.css';
import Header from './components/header';
import Herosec from './components/herosec';
import About from './components/about';
import Services from './components/services';
import Membership from './components/membership';
import Footer from './components/footer';
import Team from './components/team';
import Contact from './components/contact'; 
import TestimonialSlider from './components/testimonials';


function App() {
  return (
   <>
    <Header/>
    <Herosec/>
    <Services/>
    <About/>
    <Team/>
    <Membership/>
    <TestimonialSlider/>
    <Contact/>
    <Footer/>
   </>
  );
}

export default App;
